// extracted by mini-css-extract-plugin
export default {"title":"SectionHeader_title__1GNtj","titleSection":"SectionHeader_titleSection__0FraY"};